import { Link } from "react-router-dom";
import { LogoFull } from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, eyebrow, children }) {
  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="legal-page">
      {/* Mini header */}
      <header className="sticky top-0 z-50 bg-black/85 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 md:px-12 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="flex items-center gap-2 group"
          >
            <LogoFull height={32} color="#FFFFFF" accent="#D4AF37" jewel="#A93043" />
          </Link>

          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="hidden sm:flex items-center gap-2 font-body text-xs tracking-[0.2em] uppercase text-white/60 hover:text-[#D4AF37] transition-colors"
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              Zurück
            </Link>
            <LanguageSwitcher />
          </div>
        </div>
      </header>

      {/* Hero band */}
      <section className="relative border-b border-[#1f1f1f] py-20 sm:py-28 kh-section-cinematic">
        <div className="absolute inset-0 pointer-events-none opacity-25"
          style={{ background: "radial-gradient(ellipse at center top, rgba(123, 30, 46, 0.35), transparent 60%)" }}
        />
        <div className="relative max-w-5xl mx-auto px-6 sm:px-8 md:px-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-[#A93043]" />
            <span className="kh-chapter">{eyebrow}</span>
            <span className="h-px w-8 bg-[#A93043]" />
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase text-white leading-[0.92]">
            {title}
          </h1>
        </div>
      </section>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 sm:px-8 md:px-12 py-20 prose-legal">
        {children}
      </main>

      {/* Footer mini */}
      <footer className="border-t border-[#1f1f1f] py-10 mt-10">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 md:px-12 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-6 text-xs font-body tracking-[0.15em] uppercase text-white/40">
            <Link to="/impressum" className="hover:text-[#D4AF37] transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-[#D4AF37] transition-colors">Datenschutz</Link>
            <Link to="/agb" className="hover:text-[#D4AF37] transition-colors">AGB</Link>
          </div>
          <p className="font-serif-luxury italic text-xs text-[#D4AF37]/70">
            © {new Date().getFullYear()} KirchHero — Vol. 01
          </p>
        </div>
      </footer>
    </div>
  );
}
